import { Injectable } from '@angular/core';
import { JobApiService } from './job.api.service';
import { Job } from '../../models/job';
import { Observable } from 'rxjs/Observable';
import { Project } from '../../models/project';
import { RouteDraft } from '../../models/routeDraft';
import { ConfigService } from '../../../../utils/config-service';

@Injectable()
export class JobDomainService {
    private baseUrl: string;

    constructor(private jobApiService: JobApiService) { }

    getAllJobs(): Observable<{} | Job[]> {
        return this.jobApiService.getAllJobs();
    }

    getAllUnfilteredJobs(): Observable<{} | Job[]> {
        return this.jobApiService.getAllUnfilteredJobs();
    }

    getAllJobsInProjects(): Observable<{} | Job[]> {
        return this.jobApiService.getAllJobsInProjects();
    }

    getAllArchivedJobs(): Observable<{} | Job[]> {
        return this.jobApiService.getArchivedJobs();
    }

    getJob(jobId: string): Observable<void | Job> {
        return this.jobApiService.getJob(jobId);
    }

    getJobStatus(jobId: string): Observable<{} | string> {
        return this.jobApiService.getJobStatus(jobId);
    }

    createJob(jobDto: Job): Observable<any> {
        return this.jobApiService.createJob(jobDto);
    }

    archiveJob(jobId: string, archive: boolean): Observable<any> {
        return this.jobApiService.archiveJob(jobId, archive);
    }

    shareProject(projectId: string, share: boolean): Observable<any> {
        return this.jobApiService.shareProject(projectId, share);
    }

    shareJob(jobId: string, share: boolean): Observable<any> {
        return this.jobApiService.shareJob(jobId, share);
    }

    deleteJob(jobId: string): Observable<any> {
        return this.jobApiService.deleteJob(jobId);
    }

    stopJob(jobId: string): Observable<any> {
        return this.jobApiService.stopJob(jobId);
    }

    getProjects(): Observable<{} | Project[]> {
        return this.jobApiService.getProjects();
    }

    getProjectById(projectId: string): Observable<{} | Project> {
        return this.jobApiService.getProjectById(projectId);
    }

    createProject(project: Project): Observable<{} | any> {
        return this.jobApiService.createProject(project);
    }

    deleteProject(projectId: string): Observable<{} | any> {
        return this.jobApiService.deleteProject(projectId);
    }
    getAllArchivedProjects(): Observable<{} | Project[]> {
        return this.jobApiService.getArchivedProjects();
    }

    archiveProject(projectId: string, archive: boolean): Observable<any> {
        return this.jobApiService.archiveProject(projectId, archive);
    }

    addJobToProject(jobId: string, projectId: string): Observable<any> {
        return this.jobApiService.addJobToProject(jobId, projectId);
    }

    getTimezoneForJob(jobId: string): Observable<{} | string> {
        return this.jobApiService.getTimezoneForJob(jobId);
    }

    getDraftRoutesFromLocalStorage(): RouteDraft[] {
        const json = localStorage.getItem('draft-routes');
        return json ? JSON.parse(json).map(j => new RouteDraft(j)) : null;
    }

    getRouteDraftFromLocalStorage(jobId: string): RouteDraft {
        const drafts = this.getDraftRoutesFromLocalStorage();
        if (!drafts) { return null; }
        return drafts.find((d: RouteDraft) => d.jobId === jobId);
    }

    saveDraftRoutesToLocalStorage(draftRoutes: RouteDraft[]): void {
        let existingDrafts = this.getDraftRoutesFromLocalStorage();
        if (!existingDrafts) {
            existingDrafts = [];
        }
        existingDrafts = [...existingDrafts, ...draftRoutes];
        localStorage.setItem('draft-routes', JSON.stringify(existingDrafts));
    }

    deleteRouteDraftFromLocalStorage(jobId: string): void {
        let draftRoutes = this.getDraftRoutesFromLocalStorage();
        if (!draftRoutes) { return; }
        const draftRoute = draftRoutes.find((d: RouteDraft) => d.jobId === jobId);
        if (!draftRoute) { return; }

        draftRoutes.splice(draftRoutes.indexOf(draftRoute), 1);
        localStorage.setItem('draft-routes', JSON.stringify(draftRoutes));
    }

    clearDraftRoutesFromLocalStorage(): void {
        localStorage.removeItem('draft-routes');
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/job/job.domain.service.ts